import React, { Dispatch, SetStateAction, useEffect, useRef } from 'react'
import {
    StyledScheduleButton,
    StyledUpdateSchedule,
} from './UpdateSchedule.styled'

export function UpdateSchedule({
    isOpen,
    setScheduleOpen,
}: {
    isOpen: boolean
    setScheduleOpen: Dispatch<SetStateAction<boolean>>
}) {
    const scheduleEl = useRef<HTMLElement | null>(null)

    const updateTimes: { [key: string]: string }[] = [
        { state: 'WA', time: 'Between 3pm and 7pm' },
        { state: 'NT', time: '1pm' },
        { state: 'SA', time: 'Between 3pm and 4pm' },
        { state: 'QLD', time: 'Between 10am and 1pm' },
        { state: 'NSW', time: '9am' },
        { state: 'VIC', time: '9am' },
        { state: 'ACT', time: '11am' },
        { state: 'TAS', time: '10am' },
    ]
    useEffect(() => {
        function handleClickOutside(event: any) {
            const clickedOutside =
                scheduleEl.current && !scheduleEl.current.contains(event.target)
            if (isOpen && clickedOutside) {
                setScheduleOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    })
    return (
        <StyledUpdateSchedule
            isOpen={isOpen}
            ref={(el) => (scheduleEl.current = el)}
        >
            <h3>Update schedule for COVID-19 Tracker</h3>
            <p>
                Our tracker updates as new data comes in, which means that
                update times vary between states.
            </p>
            <p>
                If you’re looking for data on a specific state, check the
                estimated update time below.
            </p>

            <p>
                <b>All times are estimates and in AWST</b>
            </p>

            <ul>
                {updateTimes.map((times) => {
                    return (
                        <li key={times.state}>
                            <b>{times.state}</b> : {times.time}
                        </li>
                    )
                })}
            </ul>
            <StyledScheduleButton onClick={() => setScheduleOpen(false)}>
                Close
            </StyledScheduleButton>
        </StyledUpdateSchedule>
    )
}
